import React from "react";
import { useNavigate , Link} from 'react-router-dom';
import Header from "../Component/Header";
import AdminHeader from "../Component/AdminHeader";
import Footer from "../Component/Footer";
import SubMenu from "../Component/SubMenu";
import { useContext } from 'react';
import { ArgContext } from '../../Context/ArgProvider';

import mainBg from "../../assets/img/bg-ai-10.jpg";
import aiImg from "../../assets/img/ai-WISvoice.png";
import aiIcon01 from "../../assets/img/icon-ai24.png";
import aiIcon02 from "../../assets/img/icon-ai02.png";
import aiIcon03 from "../../assets/img/icon-ai25.png";
import aiIcon04 from "../../assets/img/icon-ai14.png";

function WISvoice() {
    // 화면 이동을 위한 네비게이터 설정
	const navigate = useNavigate();

	// 일반 또는 관리자 header 설정
	const { argInfo } = useContext(ArgContext);
	const isAdmin = argInfo?.role === 'admin';

  //파일다운로드
    const downloadFile = async () => {
    const response = await fetch("/download/brochure");
    const blob = await response.blob();
  
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "위피아_AI솔루션.pdf";
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };

  
    return (<>
	<main className="page-wrapper">
		{isAdmin ? <AdminHeader /> : <Header />}
      {/* <!-- 메인 미이지 + 슬로건 --> */}
			<section className="sub-bannerWrap comOverview-banner" style={{backgroundImage: `url(`+mainBg+`)`}} >
					<div className="textBox">
            <span className="ko">실시간 음성 서비스 솔루션</span>
						<h2>WISvoice</h2>
						<p>텍스트 음성 변환, 다중 화자 인식과 음성 명령 처리가 가능한 실시간 AI 음성 인터페이스 솔루션. 비즈니스와 생활 속 다양한 서비스 경험을 혁신합니다.</p>
					</div>
					<SubMenu />
			</section>

			<section className="container-auto sec-my ai-business-wrap">
        <section className="aiCont">
          <h4 className="title">
            <span>연관 솔루션</span>
          </h4>

          <h5 className="title">기업·기관의 비즈니스 프로세스를 혁신하세요!</h5>
          <p className="text">조직 내 모든 유형의 <span className="blue">AI 서비스와 데이터</span>를 손쉽게 연결하고, 통합된 환경에서 안전하게 운영·확장할 수 있는 엔터프라이즈 AI 허브이자, 업무 혁신의 디지털 플랫폼입니다.<br/>
          <span className="blue">복수의 AI 엔진, 멀티모달 데이터, 외부/기존 IT 시스템 및 다양한 채널</span>과의 연계를 필요로 하는 기업·기관에 특히 적합합니다.<br/>
          플랫폼 도입 시 즉각적 디지털 전환 효과와 <span className="blue">지속적 AI 확장 기반</span>을 함께 확보할 수 있습니다.</p>
          <ul className="link-wrap">
            <li> <Link to="/WISplatform">WISplatform <i></i></Link></li>
            <li> <Link to="/WISaicc">WISaicc <i></i></Link></li>
            <li> <Link to="/WISbot">WISbot <i></i></Link></li>
            <li> <Link to="/WISserch">WISsearch <i></i></Link></li>
            <li> <Link to="/WISvec">WISvec <i></i></Link></li>
            <li> <Link to="/WISrag">WISrag <i></i></Link></li>
            <li> <Link to="/WISdoc">WISdoc <i></i></Link></li>
            <li> <Link to="/WISscrap">WISscrap <i></i></Link></li>
            <li> <Link to="/WISocr">WISocr <i></i></Link></li>
            <li> <Link to="/WISvision">WISvision <i></i></Link></li>
          </ul>
        </section>
        <section className="aiCont">
          <h4 className="title ">
          <span>WISvoice 란?</span>
        </h4>
        <div className="textWrap">
            <div className="ai-ci"><img src={aiImg} alt="WISvoice" /></div>
            <div className="info">
              <p>WISvoice는 AI 기반의 실시간 음성 인식(STT), 음성 합성(TTS), 음성 명령 처리 등 다양한 음성 인터페이스 기능을 제공하는 통합 음성 서비스 솔루션입니다. 사람과 시스템이 음성으로 자연스럽게 상호작용할 수 있도록 지원하며, 다양한 산업(스마트홈, 콜센터, 회의, IoT, 모빌리티 등)에 유연하게 적용됩니다.</p>

              <ul className="list">
                <li>
                  <p className="tit">실시간 음성 인식(STT)</p>
                  <p className="txt">사용자의 음성을 텍스트로 변환하거나, 음성 명령을 해석하여 특정 동작을 수행</p>
                </li>
                 <li>
                  <p className="tit">고품질 음성 합성(TTS)</p>
                  <p className="txt">자연스러운 음색, 감정 표현 가능한 여러 목소리 지원 안내, 알림, 챗봇 응답 등 다양한 음성 출력 자동화</p>
                </li>
                 <li>
                  <p className="tit">음성 명령 인식 및 실행</p>
                  <p className="txt">특정 키워드 또는 자유로운 음성 명령 인식 서비스/디바이스(Control API)와 연동하여 이벤트 트리거</p>
                </li>
                 <li>
                  <p className="tit">대화내용 기록 및 분석</p>
                  <p className="txt">회의·상담·컨퍼런스의 음성 자동 녹음 및 텍스트 변환 대화 요약, 의도 분석, 주요 키워드 및 감정 인식 지원</p>
                </li>
              </ul>
            </div>
        </div>
        </section>

        <section className="aiCont">
          <h4 className="title ">
            <span>특장점</span>
          </h4>
          <ul className="textWrap feature-list">
            <li>
              <span className="icon"><img src={aiIcon01} alt="딥러닝 기반 STT/TTS"/></span>
              <p className="tit">딥러닝 기반<br/> STT/TTS</p>
              <p className="txt">최신 음향 모델(Transformer, Conformer 등) 적용<br/>낮은 소음 환경뿐 아니라, 잡음 많고 복잡한 환경에서도 높은 인식률</p>
            </li>
            <li>
              <span className="icon"><img src={aiIcon02} alt="모바일·웹·IoT 등 다양한 인터페이스"/></span>
              <p className="tit">모바일·웹·IoT 등<br />다양한 인터페이스</p>
              <p className="txt">SDK·API 제공, 손쉬운 타 시스템/앱 연동 실시간, 배치 처리 모두 가능</p>
            </li>
            <li>
              <span className="icon"><img src={aiIcon03} alt="사용자 맞춤형 커스터마이징"/></span>
              <p className="tit">사용자 맞춤형 <br />커스터마이징</p>
              <p className="txt">회사별 업무 시나리오, 용어, 화자, 명령어 등 도메인 특화시스템 구축<br/>음성 사전·명령어 관리 기능 제공</p>
            </li>
            <li>
              <span className="icon"><img src={aiIcon04} alt="보안 및 개인정보 보호"/></span>
              <p className="tit">보안 및 <br/>개인정보 보호</p>
              <p className="txt">통신·저장 단계 암호화, 음성 데이터 비식별화 적용 가능</p>
            </li>
          </ul>
        </section>
        <section className="aiCont">
          <h4 className="title ">
            <span>아키텍처</span>
          </h4>
          <ul className="textWrap ac-list">
              <li>
                <p className="tit">음성 입력 신호</p>
                <p className="txt">마이크/전화/녹음파일</p>
              </li>
              <li>
                <p className="tit">STT 엔진</p>
                <p className="txt">실시간음성 ⇒ 텍스트 변환</p>
              </li>
              <li>
                <p className="tit">분석 모듈</p>
                <p className="txt">명령어/의도 분석</p>
              </li>
              <li>
                <p className="tit">TTS 엔진</p>
                <p className="txt">텍스트 ⇒음성 합성 (필요시)</p>
              </li>
              <li>
                <p className="tit">API 연계</p>
                <p className="txt">이벤트/외부서비스 연계</p>
              </li>
              <li>
                <p className="tit">회의·대화분석</p>
                <p className="txt">리포팅/알림시스템</p>
              </li>
            </ul>
        </section>


        <section className="aiCont">
          <h4 className="title">
            <span>활용사례</span>
          </h4>
          <ul className="textWrap case-list">
              <li>
                <p className="tit">스마트홈/IoT</p>
                <p className="txt">음성 명령으로 가전제어, 상태 조회, 홈오토메이션</p>
              </li>
                <li>
                <p className="tit">콜센터·고객상담</p>
                <p className="txt">자동상담, 콜 대화 기록, 감정/의도 분석, 윤리 모니터링</p>
              </li>
                <li>
                <p className="tit">업무회의/컨퍼런스</p>
                <p className="txt">회의록 자동생성, 참여자 발언 구분, 주요 의사결정 요약</p>
              </li>
              <li>
              <p className="tit">IVR/ARS</p>
              <p className="txt">고객 셀프 서비스 제공, 자연어 질의 음성 응답</p>
            </li>
            <li>
              <p className="tit">차량·모빌리티</p>
              <p className="txt">고객 셀프 서비스 제공, 자연어 질의 음성 응답</p>
            </li>
            <li>
              <p className="tit">공공/교육</p>
              <p className="txt">실시간 다국어 통역, 장애인·노년층 음성지원 서비스</p>
            </li>
          </ul>
          
        </section>

        <section className="aiCont">
          <div className="btnWrap">
            <button type="button" className="inquiry-btn" onClick={downloadFile}>브로슈어 다운로드</button>
          </div>
        </section>
        
			</section>
		</main>
	<Footer />

        </>
    )
}

export default WISvoice;